// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import request from './request'

const serveName = process.env.VUE_APP_SERVENAME
// 客诉看板查询接口
export const queryWechatComplaintStatistics = (data: any) =>
  request(`/${serveName}/complaint/dashboard`, null, 'POST_JSON', data)
// 被诉商户下拉接口
export const queryComplaintMerchantOptions = (data: any) =>
  request(`/${serveName}/complaint/filter/complained-merchants/options`, null, 'POST_JSON', data)
// 被诉产品下拉接口
export const queryComplaintProductOptions = (data: any) =>
  request(`/${serveName}/complaint/filter/complained-products/options`, null, 'POST_JSON', data)
// 问题描述下拉接口
export const queryComplaintProblemDescriptionOptions = (data: any) =>
  request(`/${serveName}/complaint/filter/problem-descriptions/options`, null, 'POST_JSON', data)
// 客诉表格查询接口
export const queryWechatComplaintList = (data: any) => request(`/${serveName}/complaint/page`, null, 'POST_JSON', data)

// 客诉单详情
export const queryWechatComplaintDetail = (data: any) =>
  request(`/${serveName}/complaint/detail`, null, 'POST_JSON', data)

export const queryWechatComplaintNegotiationPage = (data: any) =>
  request(`/${serveName}/complaint/negotiation/page`, null, 'POST_JSON', data)

export const queryQuickReplyTemplates = () =>
  request(`/${serveName}/complaint/quick-reply/templates`, null, 'GET', null)

export const replyWechatComplaint = (data: any) =>
  request(`/${serveName}/complaint/action/reply`, null, 'POST_JSON', data)

export const resendWechatComplaintOrder = (data: any) =>
  request(`/${serveName}/complaint/action/resend`, null, 'POST_JSON', data)

export const submitWechatComplaintRefund = (data: any) =>
  request(`/${serveName}/complaint/action/refund/approve`, null, 'POST_JSON', data)

export const finishWechatComplaint = (data: any) =>
  request(`/${serveName}/complaint/action/complete`, null, 'POST_JSON', data)

export const batchRefundWechatComplaint = (data: any) =>
  request(`/${serveName}/complaint/batch/refund`, null, 'POST_JSON', data)

export const batchReplyWechatComplaint = (data: any) =>
  request(`/${serveName}/complaint/batch/reply`, null, 'POST_JSON', data)

export const batchFinishWechatComplaint = (data: any) =>
  request(`/${serveName}/complaint/batch/complete`, null, 'POST_JSON', data)

export const exportWechatComplaintList = (data: any) =>
  request(`/${serveName}/complaint/export`, null, 'POST_DOWNLOAD', data)

export const uploadComplaintImage = (data: FormData) =>
  request(`/${serveName}/complaint/media/wechat/upload`, null, 'POST_FILE', data, 120000)

export const queryComplaintMediaPreview = (params: { mediaId: string; complaintMainId: string | number }) =>
  request(`/${serveName}/complaint/media/wechat/preview`, params, 'GET', null)
